/**
 * The one place the panel writes to the console.
 *
 * `no-console` is on everywhere else so a stray `console.log` of a response body cannot
 * ship. An error that nothing caught is the exception the rule exists to allow: it goes
 * to the console because the console is where a developer reproducing a ticket looks,
 * and a toast is what the operator sees. Both happen; neither is logging.
 */
export function reportError(scope: string, error: unknown): void {
  // eslint-disable-next-line no-console -- the single sanctioned console sink, see above
  console.error(`[${scope}]`, error)
}
